/**
 * Canonical ordering of `EntityRoot` literals — the same six roots
 * declared in `packages/shared/src/pack.ts` plus the display order
 * the UI uses for surfaces that iterate them (root picker, palette
 * quick-create rows, entity-list filter chips in #132).
 *
 * The order matches `entity.new.*` / `entity.root.*` i18n keys; do
 * NOT reorder without updating those keys (the closure test in
 * `packages/shared/src/entity-root-closure.test.ts` keeps the union
 * itself honest, but display order is a UI concern).
 *
 * Lives at the client root so the palette (`./palette/*`), the entity
 * list view, and the entity-creation root picker can all share the
 * same constant without one depending on the other's module file.
 */
import { type EntityRoot } from '@dl/shared';

export const ALL_ENTITY_ROOTS: readonly EntityRoot[] = [
  'location',
  'character',
  'faction',
  'event',
  'item',
  'lore',
];
